export const AUTO_FILL_CHECK_REQUIRED = 'autofillCheckRequired';
